import { React } from "react";
import Slider from "react-slick";
import { useSelector } from "react-redux";
import { bannerone } from "../redux/selectors";
import { Helmet } from "react-helmet-async";

const BannerOne = () => {
    const data = useSelector(bannerone("landing"));
    const seo_data = useSelector((state) => state?.seo_data?.seo_data) ?? {};

    //console.log('seo_datas  ', seo_data);

    function SampleNextArrow(props) {
        const { className, onClick } = props;
        return (
            <button
                type="button"
                onClick={onClick}
                className={` ${className} slick-next slick-arrow flex-center rounded-circle bg-white text-xl hover-bg-main-600 hover-text-white transition-1`}
            >
                <i className="ph ph-caret-right" />
            </button>
        );
    }

    function SamplePrevArrow(props) {
        const { className, onClick } = props;

        return (
        <button
            type="button"
            onClick={onClick}
            className={`${className} slick-prev slick-arrow flex-center rounded-circle bg-white text-xl hover-bg-main-600 hover-text-white transition-1`}
        >
            <i className="ph ph-caret-left" />
        </button>
        );
    }
    const settings = {
        dots: false,
        arrows: true,
        infinite: true,
        speed: 1500,
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 0,
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,
    };

    if (data?.length > 0) {
        return (
            <>
                {seo_data && (
                    <Helmet>                    
                        <title>{seo_data?.title }</title>   
                        <meta name="description" content={seo_data?.description}  />
                        <meta property="og:title" content={seo_data?.title} />
                        <meta property="og:description" content={seo_data?.description} />                 
                    </Helmet>          
                )}
                <div className="banner">
                    <div className="container container-lg">
                        <div className="banner-item rounded-24 overflow-hidden position-relative arrow-center">
                            <div>
                            <a
                                href="#featureSection"
                                className="scroll-down w-84 h-84 text-center flex-center bg-main-600 rounded-circle border border-5 text-white border-white position-absolute start-50 translate-middle-x bottom-0 hover-bg-main-800"
                            >
                                <span className="icon line-height-0">
                                <i className="ph ph-caret-double-down" />
                                </span>
                            </a>

                            {data?.length > 0 &&
                                data.map((image, index) => {
                                const imageUrl =
                                    image?.attributes?.hero_image_desktop?.files?.original?.url;
                                const fileExtension = imageUrl
                                    ?.split(".")
                                    .pop()
                                    ?.toLowerCase();
                                // const imageUrl = "/assets/images/bg/sample.mp4";
                                // const fileExtension = "mp4";
                                // <img
                                //   src="/assets/images/bg/CoorporateGiftsBanner.png"
                                //   alt=""
                                //   class="banner-img position-absolute inset-block-start-0 inset-inline-start-0 w-100 h-100 z-n1 object-fit-cover rounded-24"
                                // ></img>

                                // <img
                                //   src={
                                //     image?.attributes?.hero_image_desktop?.files?.original
                                //       ?.url
                                //   }
                                //   alt={
                                //     image?.attributes?.hero_image_desktop?.alt ||
                                //     "Default Hero"
                                //   }
                                //   className="banner-img position-absolute inset-block-start-0 inset-inline-start-0 w-100 h-100 z-n1 object-fit-cover rounded-24"
                                // />;
                                return fileExtension === "mp4" ? (
                                    <video
                                    key={index}
                                    src={imageUrl}
                                    autoPlay
                                    loop
                                    muted
                                    playsInline
                                    className="banner-img position-absolute inset-block-start-0 inset-inline-start-0 w-100 h-100 z-n1 object-fit-cover rounded-24"
                                    />
                                ) : (
                                    <img
                                    key={index}
                                    src={imageUrl}
                                    alt={image?.attributes?.hero_image_desktop?.alt}
                                    className="banner-img position-absolute inset-block-start-0 inset-inline-start-0 w-100 h-100 z-n1 object-fit-cover rounded-24"
                                    />
                                );
                                })}
                            <div className="flex-align"></div>
                            <div className="banner-slider">
                                <Slider {...settings}>
                                {/* {data?.length > 0 &&
                                        data.map((image, index) => ( */}
                                <div className="banner-slider__item">
                                    <div className="banner-slider__inner flex-between position-relative">
                                    <div className="banner-item__content"></div>
                                    <div className="banner-item__thumb">
                                        <img
                                        src="/assets/images/thumbs/banner-img3.png"
                                        className="hero-image"
                                        style={{ opacity: 0 }}
                                        alt=""
                                        />
                                    </div>
                                    </div>
                                </div>
                                {/* ))} */}
                                </Slider>
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
};

export default BannerOne;
